<template>
  <div class="problem">
    <transition name="fade" v-if="showCustom">
      <custom-service v-show="status"></custom-service>
    </transition>
    <div class="content" ref="problem">
      <router-link :to="{ path: 'search', query: { id } }">
        <gm-search disabled :placeholder="$t('search_placeholder')"></gm-search>
      </router-link>
      <gm-list :list="problems"></gm-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isMC } from '@/utils'
import GmSearch from '@/components/Search'
import GmList from '../components/List'
import CustomService from '../components/CustomService'

export default {
  name: 'list',
  components: {
    GmSearch,
    GmList,
    CustomService,
  },
  data() {
    return {
      id: '',
      status: true,
      scrollTop: 0,
    }
  },
  computed: {
    ...mapGetters({
      problems: 'getGroupList',
    }),
    showCustom() {
      const user = navigator.userAgent
      const bool =
        (user.indexOf('Version') > -1 &&
          user.indexOf('Linux') > -1 &&
          user.indexOf('MicroMessenger') === -1 &&
          user.indexOf('AliApp') === -1) ||
        (user.indexOf('iPhone') > -1 &&
          user.indexOf('Version') === -1 &&
          user.indexOf('MicroMessenger') === -1 &&
          user.indexOf('AliApp') === -1)
      return !isMC() && bool
    },
  },
  activated() {
    this.status = true
    // 通过$refs获取dom元素
    const box = this.$refs.problem
    // 监听这个dom的scroll事件
    box.addEventListener(
      'scroll',
      () => {
        if (this.scrollTop !== box.scrollTop) {
          this.status = this.scrollTop > box.scrollTop
          this.scrollTop = box.scrollTop
        }
      },
      false
    )

    const id = (this.$route.query.id || '').toString()
    if (this.id !== id) {
      this.id = id
      this.$store.dispatch('requestData', {
        method: 'list',
        payload: [],
      })
      this.$store.dispatch('requestGroupList', {
        id,
        all: this.$route.query.all,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../style/func.scss';

.problem {
  position: relative;
  height: 100%;

  .content {
    height: 100%;
    padding-bottom: px2rem(56px);
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help-center/views/ProblemList.vue